module.exports = __webpack_public_path__ + "static/media/canteenSnackGift.c5ea828a.gif";